import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from './/NavBar'


export const MainLayout = () => {
  return (
    <>
    <Navbar />
    <Outlet />
    </>
  )
}